import { render, staticRenderFns } from "./InstagramBusinessChannelFollowerActivity.vue?vue&type=template&id=10bc9441"
import script from "./InstagramBusinessChannelFollowerActivity.vue?vue&type=script&lang=js"
export * from "./InstagramBusinessChannelFollowerActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports